// extracted by mini-css-extract-plugin
export default {"hero":"HeroSerction_hero__I3TXc","title__hero":"HeroSerction_title__hero__akgZ8","text__hero":"HeroSerction_text__hero__ppg-2"};